/**
 * @generated SignedSource<<c82518c8868cdadc8c0b887607b97e67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type introduceEditorUpdateMutation$variables = {
  contenthtml?: string | null | undefined;
  contentjson?: string | null | undefined;
  userId: string;
};
export type introduceEditorUpdateMutation$data = {
  readonly update_insurance_agent_by_pk: {
    readonly id: string;
  } | null | undefined;
};
export type introduceEditorUpdateMutation = {
  response: introduceEditorUpdateMutation$data;
  variables: introduceEditorUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contenthtml"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentjson"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contenthtml",
            "variableName": "contenthtml"
          },
          {
            "kind": "Variable",
            "name": "contentjson",
            "variableName": "contentjson"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "pk_columns"
      }
    ],
    "concreteType": "insurance_agent",
    "kind": "LinkedField",
    "name": "update_insurance_agent_by_pk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "introduceEditorUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "introduceEditorUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "ae12e461b028b419d5ae76503def37a9",
    "id": null,
    "metadata": {},
    "name": "introduceEditorUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation introduceEditorUpdateMutation(\n  $userId: String!\n  $contenthtml: String\n  $contentjson: String\n) {\n  update_insurance_agent_by_pk(pk_columns: {id: $userId}, _set: {contenthtml: $contenthtml, contentjson: $contentjson}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "522b24c60c10b4f3dbe8d93583022868";

export default node;
